'use client';

import { useContext } from 'react';
import Partials from 'components/partials/Partials';
import { AppContext } from 'context/AppContext';
import type { PartialWidgetContext } from 'types/cms';
import type { PropsWithClassName } from 'types/react-props';
import { getKey } from 'utils/idGenerator';

export type GroupGridProps = PropsWithClassName<{
  readonly model: {
    readonly fields: {
      readonly displayOnViewport: 'mobile' | 'desktop';
    };
  };
  readonly children: Array<PartialWidgetContext>;
}>;

export const GroupGridViewport = ({ context }: { context: GroupGridProps }) => {
  const { device } = useContext(AppContext);

  if (device === context.model.fields.displayOnViewport) {
    return (
      <>
        {context.children.map((widget: PartialWidgetContext) => (
          <Partials key={getKey(widget.id, widget)} context={widget} />
        ))}
      </>
    );
  }
  return null;
};
